/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_CopyInputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Meeting_Transcript_CopyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_copy = /** @type {((inputs?: Meeting_Transcript_CopyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_CopyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kopiëren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier")
	return /** @type {LocalizedString} */ ("Copy")
});